import React, {Component} from 'react';
import {observable, action} from 'mobx';
import service from '../service';
import axios from "axios";
import config from "../config";

class MemberStore {

    @observable member;
    @observable error = false;

    constructor(serviceGroup, collection) {
        this.service = serviceGroup;
        this.httpClient = axios.create({
            baseURL: `http://${config.services.v2.uri}:${config.services.v2.port}`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    @action
    getCert(mcode) {
        return new Promise((resolve, reject) => {
            this.service.getCert(mcode).then(response => {
                this.member = response.data;
                resolve(true);
            }).catch(err => {
                console.log(err);
                reject(false);
            })
        });
    }

    @action
    async getMemberEventForm(mcode) {
        let response;
        try {
            const url = `api/member/getdetail`;
            response = await this.httpClient.get(url, {
                params: { mcode: mcode }});
            this.member = response.data;
        }
        catch (err) {

        }
        return {...this.member};
    }

    updateMember(key, value) {
        this.member[key] = value;
    }

    setMember(data) {
        this.member = data;
    }
}


export default new MemberStore(service.member);



// WEBPACK FOOTER //
// ./src/store/MemberStore.js